import React from 'react';
import {getPageData} from '../../sources/CmsSource';
import {useGetPageData} from '../../actions/CmsActions';
import {hot} from 'react-hot-loader';
import ServicesContainer from './Services.container';

const cmsUrlPattern = '/services';

const ServicesView = () => {
    const pageData = useGetPageData({cmsUrlPattern});
    return <ServicesContainer pageData={pageData || {}} />;
};

ServicesView.getInitialProps = async (match, {locale}) => {
    const rawPageData = await getPageData(cmsUrlPattern);

    //must match structure of StoreProvider
    return {
        cms: {
            [cmsUrlPattern]: rawPageData
        }
    };
};

export default hot(module)(ServicesView);
